import type { Language } from '@eformulieren/engine'
import type { ReactNode } from 'react'

/**
 * De naamsvermelding van de citatiestijl, onder elke literatuurlijst (R-50).
 *
 * De stijl (`assets/harvardCsl.ts`) en de locale (`assets/localeAndGb.ts`) komen uit het project
 * Citation Style Language en staan onder Creative Commons Naamsvermelding-GelijkDelen 3.0, zoals
 * hun eigen `<rights>` zegt. Die licentie vraagt een vermelding met een link naar de licentie, en de
 * CitatenPOC zet daarom "Citatiestijlen via CitationStyles.org (CC BY-SA 3.0)" in zijn uitlegpaneel
 * (`HelpPanel.tsx`, `CLAUDE.md` van de POC). Dit product heeft geen uitlegpaneel; de lijst is de plek
 * waar de stijl zichtbaar wordt, dus daar staat de regel, klein en gedempt. Wie de stijl en de locale
 * schreven staat in het `<info>`-blok van elk bestand; de naamsvermelding in de repo staat in `NOTICE`.
 *
 * Een nieuw tabblad, met dat in de naam: wie het formulier invult verliest zijn plek niet.
 */
const T = {
  stijl: { nl: 'Citatiestijl: Harvard (Cite Them Right), via', en: 'Citation style: Harvard (Cite Them Right), via' },
  nieuw: { nl: '(opent in een nieuw tabblad)', en: '(opens in a new tab)' },
} as const

export function StyleCredit({ taal: language }: { readonly taal: Language }): ReactNode {
  return (
    <p className="ef-citatiestijl">
      {T.stijl[language]}{' '}
      <a href="https://citationstyles.org/" target="_blank" rel="noreferrer">
        CitationStyles.org<span className="ef-sr-only"> {T.nieuw[language]}</span>
      </a>
      ,{' '}
      <a href="https://creativecommons.org/licenses/by-sa/3.0/" target="_blank" rel="noreferrer license">
        CC BY-SA 3.0<span className="ef-sr-only"> {T.nieuw[language]}</span>
      </a>
      .
    </p>
  )
}
